import React from 'react';
import {
  Dialog,
  Box,
  Button,
  DialogContent,
  useMediaQuery,
  DialogTitle,
  DialogActions,
  IconButton,
  Typography,
  Link,
  List,
  ListItem,
  useTheme,
} from '@mui/material';
import { AccessibilityPopupStyles } from '../styles/accessibilityPopup';
import { Close } from '@mui/icons-material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DialogStyles } from '../styles/dialog';
import { WCAGStrandardStyles } from '../styles/WCAGStandardStyles';
import { IELink } from './IELink';
import { routeMappings } from '../../constants';

interface AccessibillityPopupProps {
  title: string;
  notSupportedFeatures: string[];
  open: boolean;
  handleClose: (e: React.MouseEvent | React.KeyboardEvent) => void;
  accessibilityDialogRef: React.RefObject<HTMLDivElement>;
}

const AccessibilityPopup = (props: AccessibillityPopupProps): JSX.Element => {
  const { open, handleClose, title, notSupportedFeatures, accessibilityDialogRef } = props;

  const { t } = useTranslation();
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const { classes } = DialogStyles();
  const { classes: apClasses } = AccessibilityPopupStyles();
  const { classes: WCAGClasses } = WCAGStrandardStyles();
  const navigate = useNavigate();
  const openAccessibilityInformationPage = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
    event.preventDefault();
    navigate(routeMappings['ACCESSIBILITY_INFO']);
  };
  return (
    <Dialog
      ref={accessibilityDialogRef}
      tabIndex={-1}
      aria-labelledby="dialogTitle"
      aria-describedby="dialogContent"
      className={classes.dialogContainer}
      fullScreen={mdDown}
      open={open}
      onClose={handleClose}>
      <DialogTitle className={classes.title}>
        {/* Task Title  */}
        <Box id="dialogTitle" className={apClasses.headingContent}>
          <span className={WCAGClasses.h3}>{`${t('accessibilityNotice')}: `}</span>
          <span className={WCAGClasses.h3}>{title}</span>
        </Box>
      </DialogTitle>
      <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
        <Close />
      </IconButton>

      <DialogContent id="dialogContent" className={apClasses.content}>
        <Box className={apClasses.subContent}>
          <Typography>{t('accessibilityNoticeContent1')}</Typography>
        </Box>
        <Box className={apClasses.subContent}>
          <Typography>{t('accessibilityNoticeContent2')}</Typography>
          {/* Accessibility Notice unsupported Features  */}
          <List className={apClasses.list}>
            {notSupportedFeatures.map((notSupportedFeature: string) => (
              <Typography key={notSupportedFeature}>
                <ListItem className={apClasses.listItem}>{t(notSupportedFeature)} </ListItem>
              </Typography>
            ))}
          </List>
        </Box>
        <Box>
          <Typography>
            {t('accessibilityNoticeContent3a')}
            <Link component={RouterLink} to="" onClick={openAccessibilityInformationPage}>
              <IELink>{t('adjustmentsOrAccommodations')}</IELink>
            </Link>
            {t('accessibilityNoticeContent3b')}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions className={apClasses.footer}>
        <Button
          fullWidth={mdDown}
          className={apClasses.closeButton}
          onClick={handleClose}
          type="submit"
          variant="outlined"
          color="primary">
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccessibilityPopup;
